<template>
  <v-app>
    <v-main>
      <MainView/>
    </v-main>
  </v-app>
</template>

<script>
import MainView from './components/MainView.vue';

export default {
  name: 'App',

  components: {
    MainView,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
html, body {
  margin: 0 !important;
  padding: 0 !important;
  height: 100%;
  overflow: hidden;
}
.v-application, .v-application--wrap {
  height: 100vh !important;
  min-height: 100vh !important;
}
</style>
